import { defineStore } from "pinia"

export const useDepositFormStore = defineStore("depositForm", {
  state: () => ({
    formData: {
      currency: "",
      depositAmount: 100,
      cryptoAddress: "",
      phone: "",
      email: "",
    },
  }),
  actions: {
    setFormData(key: keyof typeof this.formData, value: any) {
      this.formData[key] = value
    },
    resetFormData() {
      this.formData = {
        currency: "",
        depositAmount: 100,
        cryptoAddress: "",
        phone: "",
        email: "",
      }
    },
  },
  getters: {
    getFormData() {
      return this.formData
    },
  },
})
